import { useCallback, useEffect, useState } from "react"
import Layout from "../../components/Layout"
import {
  Banner,
  FAQ,
  KenapaHarusMindo,
  ProgramBootcamp,
  // ProgramBootcamp,
  // ProgramBaru,
  ProgramUnggulan,
  Testimoni,
} from "./components"

import axios from "axios"
import { Link as LinkScroll } from "react-scroll"
import styles from "./home.module.css"
import BelajarMandiri from "../../components/BelajarMandiri"
import { message, Modal } from "antd"
import { CloseOutlined } from "@ant-design/icons"
import { useDispatch, useSelector } from "react-redux"
import { selectCurrentUser } from "../../redux/user/user.selectors"
import ProgramTerdekat from "./components/ProgramTerdekat"
import CareerDiagnosis from "./components/CareerDiagnosis"
import { setCurrentUser, setCurrentUserJWT } from "../../redux/user/user.action"
import api from "../../utils/api"
import ProgramFlashSale from "./components/ProgramFlashSale"
import { useSearchParams } from "react-router-dom"

const getUserTimeZone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Jakarta"
  } catch (error) {
    return "Asia/Jakarta"
  }
}

const isLandingModalActive = (modalData) => {
  if (!modalData?.isShowing) {
    return false
  }

  const now = Date.now()
  const startAt = modalData.startAt
    ? new Date(modalData.startAt).getTime()
    : null
  const endAt = modalData.endAt ? new Date(modalData.endAt).getTime() : null

  if (startAt && now < startAt) {
    return false
  }

  if (endAt && now > endAt) {
    return false
  }

  return true
}

const Home = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [programBootcampData, setProgramBootcampData] = useState(null)
  const [programTerdekatData, setProgramTerdekatData] = useState(null)
  const [programUnggulanData, setProgramUnggulanData] = useState(null)
  const [programDatas, setprogramDatas] = useState([])
  const [programFlashSaleData, setProgramFlashSaleData] = useState(null)
  const [testimoniData, setTestimoniData] = useState(null)
  const [faqData, setFaqData] = useState(null)

  const currentUser = useSelector(selectCurrentUser)
  const [dataUser, setDataUser] = useState(null)
  const [dataLandingModal, setDataLandingModal] = useState(null)
  const [isLandingModalOpen, setIsLandingModalOpen] = useState(false)

  const dispatch = useDispatch()

  const [checkProgressCareerDiagnosis, setCheckProgressCareerDiagnosis] =
    useState(null)

  const getProgramData = useCallback(async () => {
    const response = await axios(`/show-product`)
    const data = await response.data
    const programs = data.program.map((program) => {
      return { value: program.name, text: program.name }
    })
    setprogramDatas(programs)
    setProgramBootcampData(data.program)
  }, [])

  const getProgressUser = useCallback(() => {
    if (!currentUser?.token) {
      setCheckProgressCareerDiagnosis(null)
      return
    }

    console.log("current token", currentUser.token)
    axios({
      method: "get",
      url: "/career-diagnosis/user-progress",
      headers: {
        Authorization: `Bearer ${currentUser.token}`,
      },
    })
      .then((response) => {
        setCheckProgressCareerDiagnosis(response.data.data)
      })
      .catch((err) => {
        console.error("Error :", err)
      })

    // const data = await response.data

    // console.log('data progress', data)
  }, [currentUser?.token])

  const getLandingModal = useCallback(() => {
    api
      .get("/landing-modal/schedule-now")
      .then((res) => {
        const modalData = res.data?.data

        setDataLandingModal(modalData)

        setIsLandingModalOpen(isLandingModalActive(modalData))
      })
      .catch((err) => {
        console.error("Error get landing modal:", err)
      })
  }, [])

  const getFlashSale = useCallback((tokenData = null) => {
    const config = tokenData
      ? {
          headers: {
            Authorization: `Bearer ${tokenData}`,
          },
        }
      : undefined
    const url = tokenData ? "/flash-sale/schedule" : "/flash-sale/schedule"

    console.log("flash sale url", url)

    api
      .get(url, config)
      .then((res) => {
        const flashSaleData = res.data

        console.log("flashSaleData", flashSaleData.data.products)

        setProgramFlashSaleData(flashSaleData.data.products)
      })
      .catch((err) => {
        console.error("Error get flash sale:", err)
      })
  }, [])

  const upsertUserTimeZone = useCallback(() => {
    const userId = currentUser?.user?.id || currentUser?.id

    if (!currentUser?.token || !userId) {
      return
    }

    api
      .post(
        "/time-zone",
        {
          userId,
          timeZone: getUserTimeZone(),
        },
        {
          headers: {
            Authorization: `Bearer ${currentUser.token}`,
          },
        },
      )
      .catch((err) => {
        console.error("Error upsert time zone:", err)
      })
  }, [currentUser?.id, currentUser?.token, currentUser?.user?.id])

  const handleLandingModalClick = () => {
    if (dataLandingModal?.redirectUrl) {
      window.open(dataLandingModal.redirectUrl, "noopener,noreferrer")
    }
  }

  const handleCloseLandingModal = () => {
    setIsLandingModalOpen(false)
  }

  const shouldShowLandingModalCloseButton =
    dataLandingModal?.redirectUrl !== "flash_sale" ||
    Boolean(programFlashSaleData)

  const landingModalImageSrc =
    dataLandingModal?.imageSrc || dataLandingModal?.image

  const handleGetProfile = useCallback((token) => {
    upsertUserTimeZone()

    axios({
      method: "get",
      url: "/profile",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then(({ data }) => {
      console.log('profile', data)
      if(!currentUser){
        dispatch(setCurrentUser({
          message: 'success',
          user: data.user,
          token
        }))
      }
      setDataUser(data)
    })
    
    axios({
      method: "post",
      url: "/generate-token-jwt",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((res) => {
      const tokenData = res.data
      console.log("token data", tokenData.data.accessToken)
      dispatch(setCurrentUserJWT(tokenData.data))
      getFlashSale(tokenData.data.accessToken)
    })
  }, [currentUser, dispatch, getFlashSale, upsertUserTimeZone])

  useEffect(() => {
    getLandingModal()

    const googleToken = searchParams.get("token")

    if (googleToken) {
      handleGetProfile(googleToken)
      // dispatch(setCurrentUser(googleToken))
      const nextSearchParams = new URLSearchParams(searchParams)
      nextSearchParams.delete("token")
      setSearchParams(nextSearchParams, { replace: true })
    }

    axios
      .get("/show-index")
      .then((res) => {
        const data = res.data
        // setProgramBootcampData(data.program_terdekat)
        setProgramTerdekatData(data.program_terdekat)
        setProgramUnggulanData(data.program_unggulan)
        setFaqData(data.faq)
        setTestimoniData(data.testimoni)

        console.log("program terdekat", data.program_terdekat)
      })
      .catch((error) => {
        if (error.response.status === 500) {
          message.error("We are Under Maintenance")
        }
      })

    if (currentUser?.token && !googleToken) {
      handleGetProfile(currentUser?.token)
    } else {
      getFlashSale()
    }
    getProgramData()
    getProgressUser()
  }, [
    currentUser,
    dispatch,
    getFlashSale,
    getLandingModal,
    getProgramData,
    getProgressUser,
    handleGetProfile,
    searchParams,
    setSearchParams,
    upsertUserTimeZone,
  ])

  // Mengurutkan secara ascending berdasarkan waktu terdekat
  programUnggulanData?.sort(
    (a, b) =>
      Number(new Date(a.time_start.slice(0, 10))) -
      Number(new Date(b.time_start.slice(0, 10))),
  )

  return (
    <Layout idPage="homePage">
      <Modal
        centered
        closable={false}
        destroyOnClose
        footer={null}
        onCancel={handleCloseLandingModal}
        visible={isLandingModalOpen}
        width={720}
        bodyStyle={{ padding: 0 }}>
        {landingModalImageSrc && (
          <div className={styles.landingModalContent}>
            {shouldShowLandingModalCloseButton && (
              <button
                type="button"
                className={styles.landingModalCloseButton}
                onClick={handleCloseLandingModal}
                aria-label="Tutup modal">
                <CloseOutlined />
              </button>
            )}
            {dataLandingModal?.redirectUrl === "flash_sale" ? (
              <LinkScroll
                to="home-page__programFlashSale"
                activeClass="active"
                spy={true}
                smooth={true}
                offset={-204}
                duration={500}
                onClick={() => {
                  if (programFlashSaleData) {
                    setIsLandingModalOpen(false)
                  }
                }}
                // onSetActive={onSetActive === null ? null : onSetActive}
              >
                <img
                  className={styles.landingModalImage}
                  src={landingModalImageSrc}
                  alt={dataLandingModal.name || "Landing modal"}
                />
              </LinkScroll>
            ) : (
              <button
                type="button"
                className={styles.landingModalImageButton}
                onClick={handleLandingModalClick}>
                <img
                  className={styles.landingModalImage}
                  src={landingModalImageSrc}
                  alt={dataLandingModal.name || "Landing modal"}
                />
              </button>
            )}
          </div>
        )}
      </Modal>
      <div id="beranda">
        <Banner programDatas={programDatas} />
      </div>
      <div className={styles.homeInner}>
        <CareerDiagnosis
          userProgressCareerDiagnosis={checkProgressCareerDiagnosis}
        />
        {programFlashSaleData && (
          <ProgramFlashSale
            dataUser={dataUser}
            programFlashSale={programFlashSaleData}
          />
        )}
        <ProgramBootcamp
          dataUser={dataUser}
          programBootcampData={programBootcampData}
        />
        <ProgramTerdekat
          dataUser={dataUser}
          programTerdekatData={programTerdekatData}
        />
        <ProgramUnggulan
          programUnggulanData={programUnggulanData}
          dataUser={dataUser}
        />
        {/* <ProgramBaru
          programTerbaruData={programTerbaruData}
          dataUser={dataUser}
        /> */}
        <Testimoni testimoniData={testimoniData} />
        <KenapaHarusMindo />
        <FAQ faqData={faqData} />
        <BelajarMandiri />
      </div>
    </Layout>
  )
}

export default Home
